import { render } from "./ContentComment.vue?vue&type=template&id=5eaf2e20&scoped=true&ts=true"
import script from "./ContentComment.vue?vue&type=script&lang=ts"
export * from "./ContentComment.vue?vue&type=script&lang=ts"

import "./ContentComment.vue?vue&type=style&index=0&id=5eaf2e20&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eaf2e20"]])

export default __exports__